<template>
	<div class="filter-wrapper " @click.self="this.popoverMc = false;"
		:class="this.highlight ? 'selected' : 'not-selected' " style="border:1px solid var(--grey-5);border-radius:5px;">

		<div style="" :title="this.title" :class="this.disabled ? '' : 'link' ">

			<div class="filter-button" style="padding:5px;" @click="this.togglePopover()">
				<div class="flexcenter " style="height:26px;">
					<Icon v-if="this.brand" :fileName="this.highlight ? 'w3_circle_close_white' : 'w3_circle_close_dark' "
						style="width:16px;height:16px;" @click.stop="this.setBrand(null); this.popoverMc = false;" />

					<b style="" class="font-normal" :class="this.disabled ? 'disabled' : 'enabled' ">{{ this.brand ?
						this.brand.name : 'MC' }}</b>



				</div>
				<div class="flexcenter filter-button-label" style="flex-grow:1;">
					<div class="font-small" style="flex-grow:1;" :class="this.disabled ? 'disabled' :'enabled' "> {{ this.mc ?
						this.mc.modelName : 'Välj&nbsp;mc-modell' }}</div>



					<div v-if="this.mc" style="padding:2px 5px 2px 5px;border-radius:3px;margin-left:5px;font-weight: bold;"
						class="font-small yearBadge"> {{
						this.year ?
						this.year.year :
						'Alla&nbsp;årtal' }}
					</div>


					<Icon v-if="!this.highlight && this.popoverMc" fileName="w3_chevron_up_dark"
						style="width:12px;height:12px;margin-left:10px;" />


					<Icon v-if="this.highlight" :fileName="this.popoverMc ? 'w3_chevron_up_white' : 'w3_chevron_down_white'"
						style="width:12px;height:12px;margin-left:10px;" />

					<!-- om boxen är disabled/enabled -->
					<Icon v-if="!this.highlight && !this.popoverMc"
						:fileName="this.disabled ? 'w3_chevron_down_light' : 'w3_chevron_down_dark'"
						style="width:12px;height:12px;margin-left:10px;" :link="!this.disabled" />

				</div>
			</div>

			<div v-show="this.popoverMc" class="dropdown dropdown-w400 dropdown-h400 dropdown-p10 dropdown-shadow"
				style="background:var(--grey-3);" @mouseleave="this.popoverMc = false;">

				<div style="height:100%;">



					<div v-if="this.mcTree" style="height:100%;">

						<!-- lista märken -->
						<div v-show="!this.brand" style="height:100%;">

							<!-- sök mc-märke-->
							<div v-if="1 == 2" style="height:50px;">

								<div class="form textField" :title="'filter: ' + this.filterBrand" style="height:30px;padding:0px;">
									<input type="text" placeholder="Sök mc-modell..." v-model="filterBrand" />
									<img src="@/assets/button_close_dark.png" @click="this.filterBrand = ''"
										style="height:20px;width:20px;margin-right:5px;" />
								</div>


							</div>

							<div v-if="!this" class="flexcenter" style="padding-bottom:5px;">
								<h3>Välj mc</h3>
								<b style="flex-grow:1;">&nbsp;</b>
								<img src="@/assets/button_close_dark.png" @click="this.popoverMc = false;"
									style="height:20px;width:20px;margin-right:5px;" />

							</div>



							<!-- lista alla mc-->

							<div ref="brandList" title="brandList" style="overflow:scroll;max-height: calc(100% - 130px);">

								<div v-for="(brand) in filterBrandList(mcTree)" :key="brand.id" ref="brands" :id="'brand-' + brand.id"
									:title="'brand-' + brand.id"
									style="background:var(--grey-2);margin-bottom:5px;padding:0px 0px 0px 0px;" class="link">

									<div class="mcLabel" style="background:var(--grey-4);border-radius: 0px;position:sticky;top:0px;"
										@click=" this.brand && this.brand.id == brand.id ? this.setBrand(null) : this.setBrand(brand);">
										<b style="" :title="brand.id"> {{ brand.name }} {{ this.isBrandEnabledLabel(brand) }}</b>
									</div>
								</div>

							</div>


							<!-- lista med logos -->
							<div style="width:100%;" class="brandLogoList">


								<div v-if="this.isBrandIdEnabled(2044)" class="brandBox" @click="selectBrand(2044);">
									<img src="https://www.boove.se/static/media/aprilia.f039aa6c.png" />
								</div>

								<div v-if="this.isBrandIdEnabled(2229)" class="brandBox" @click="selectBrand(2229);">
									<img src="https://www.boove.se/static/media/bmw.54b060da.png" />
								</div>

								<div v-if="this.isBrandIdEnabled(2550)" class="brandBox" @click="selectBrand(2550);">
									<img src="https://www.boove.se/static/media/ducati.68547372.png" />
								</div>

								<div v-if="this.isBrandIdEnabled(5241)" class=" brandBox" @click="selectBrand(5241);">
									<img src="https://www.boove.se/static/media/hd.20b1ce93.png" />
								</div>

								<div v-if="this.isBrandIdEnabled(4424)" class="brandBox" @click="selectBrand(4424);">
									<img src="https://www.boove.se/static/media/honda.48add75d.png" />
								</div>

								<div v-if="this.isBrandIdEnabled(3751)" class="brandBox" @click="selectBrand(3751);">
									<img src="https://www.boove.se/static/media/huskvarna.b5492f38.png" />
								</div>

								<div v-if="this.isBrandIdEnabled(4241)" class="brandBox" @click="selectBrand(4241);">
									<img src="https://www.boove.se/static/media/kawasaki.9b2c5f93.png" />
								</div>

								<div v-if="this.isBrandIdEnabled(4101)" class=" brandBox" @click="selectBrand(4101);">
									<img src="https://www.boove.se/static/media/ktm.25473821.png" />
								</div>

								<div v-if="this.isBrandIdEnabled(5446)" class="brandBox" @click="selectBrand(5446);">
									<img src="https://www.boove.se/static/media/mv-agusta.2b5af30c.png" />
								</div>

								<div v-if="this.isBrandIdEnabled(4723)" class="brandBox" @click="selectBrand(4723);">
									<img src="https://www.boove.se/static/media/suzuki.5ab4584b.png" />
								</div>

								<div v-if="this.isBrandIdEnabled(5264)" class="brandBox" @click="selectBrand(5264);">
									<img src="https://www.boove.se/static/media/triumph.37066cbd.png" />
								</div>

								<div v-if="this.isBrandIdEnabled(4931)" class=" brandBox" @click="selectBrand(4931);">
									<img src="https://www.boove.se/static/media/yamaha.e7e8bfc4.png" />
								</div>



							</div>

						</div>


						<!-- om vi har ett märke-->
						<div v-show="this.brand" style="height:100%;">
							<div v-if="this.brand" style="background:var(--grey-4);padding:5px;border-radius: 5px;" class="flexcenter"
								@click.self="this.popoverMc = false;">

								<Icon fileName="w3_chevron_left_dark" style="width:10px;height:16px;margin-right:5px;"
									@click="this.setBrand(null);" />
								<h3 @click="this.setBrand(null);">{{ this.brand.name }}</h3>

								<b style="flex-grow:1;">&nbsp;</b>

								<img src="@/assets/w3_button_close_dark.png" @click="this.popoverMc = false;"
									style="height:20px;width:20px;margin-right:0px;" class="link" />


							</div>

							<div v-if="this.brand" style="height:30px;margin-top:10px;margin-bottom:10px;">

								<div class="form textField" :title="'filter: ' + this.filterMc" style="height:30px;padding:0px;">
									<input type="text" :placeholder="'Sök ' + this.brand.name + ' modeller'" v-model="filterMc" />
									<img v-if="this.filterMc" src="@/assets/w3_button_close_light.png" @click="this.filterMc = ''"
										style="height:20px;width:20px;margin-right:5px;" />
								</div>


							</div>

							<div ref="mcList" style="overflow:scroll;max-height: calc(100% - 90px);">

								<!-- mc list för valt märke -->
								<div v-for="mc in this.brand && filterMcList(this.brand.modelList)" :key="mc.mcId" ref="mcs"
									:id="'mc-' + mc.mcId" style="background:var(--grey-4);margin-top:5px;border-radius:5px;"
									@click="this.setMc(mc)">
									<div class="link mcLabel">
										{{ mc.modelName }}
									</div>


									<!-- årsmodeller -->
									<div v-if="this.mc && this.mc.mcId == mc.mcId" style="margin-top:0px;">
										<div style="display:flex;justify-content:start;gap:5px 3px; flex-wrap: wrap; padding:5px;">

											<div
												style="padding:3px;border-radius:3px;background:var(--grey-2);border:1px solid var(--grey-2);"
												:style="!this.year ? 'border:1px solid var(--grey-6);' : ''" class="link"
												@click.stop="this.setYear(null); this.popoverMc = false">
												Alla år</div>


											<div
												v-for="year in this.mc && this.mc.yearList.filter(year => year != null).sort((a, b) => b.year - a.year)"
												:key="year.year"
												style="padding:3px;border-radius:3px;background:var(--grey-2);border:1px solid var(--grey-2);"
												class="link"
												:style="this.year && this.year.year == year.year ? 'border:1px solid var(--grey-6);' : ''"
												@click.stop="this.setYear(year); this.popoverMc = false;">
												{{ year.year }}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>
<script>
import { STORE_GETTER } from '../../../store/store';


//import SelectManufactor from '@/components/product/search/SelectManufactor.vue';
//import { STORE_GETTER } from '@/store/store';

export default {
	name: "SelectMc",
	components: {},
	mixins: [],
	props:{
		baseMcList: Array,
		baseMcTree: Array,
		brand: Object,
		mc: Object,
		year: Object,
		
	},
	data() {
		return {
			popoverMc: false,
			filterBrand: null,
			filterMc: null,
		};
	},
	computed: {

		mcList() {

			return this.baseMcList;

		},
		mcTree() {

		return this.baseMcTree;

		},
		
		enabledMcIdMap(){
			return this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_RESULT]?.mcIdMap
		},

		highlight(){
			const searchProductConfig = this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_CONFIG];
			if (!searchProductConfig){
				return false;
			}

			return searchProductConfig.brand || searchProductConfig.mc || searchProductConfig.year;
		},
		title(){
			if (!this.disabled){
				return "Välj mc-märke och modell"
			}else{
				return "Välj först 'Alla produkter' du visar bara ett urval av produkter. ";
			}
		},
		disabled() {
			return !this.$store.getters[STORE_GETTER.PRODUCT_SEARCH_ENABLED];
		}


	},
	watch: {
		/*brand: function (brand) {
			this.mc = null
			this.year = null
			console.log('FP: brand: ', brand);
			//this.setupScroll()
			this.filterMc = null

		},
		mc: function (mc) {
			this.year = null
			console.log('FP: mc: ', mc);
			//this.setupScroll()
		},
		year: function (year) {
			console.log('FP: year', year);
			//this.setupScroll()
		},*/
		popoverMc: function (popoverMc) { // TODO kolla om denna behövs


			if (this.popoverMc){
				this.$emit("selectPopoverOpen", "popoverMc");
			}
			

			console.log('FP: popoverMc', popoverMc);


			setTimeout(() => {
				this.setupScroll()
			}, 500);


		},
	},
	methods: {
		togglePopover(){
			if (this.disabled){
				alert(this.title)

				return;
			}

			this.popoverMc = !this.popoverMc
		},
		closePopover(){
			this.popoverMc = false
		},
		exportSelectMc(){
			alert("exportSelectMc");
		},
		
		setBrand(brand){
			this.$emit("brandSelected", brand);
			this.setMc(null);
			this.setYear(null);
			this.filterMc = null;
		},
		setMc(mc){
			this.$emit("mcSelected", mc);
			this.setYear(null);
		},
		setYear(year){
			//alert("setYEar");
			this.$emit("yearSelected", year);
			//alert(year.year)
			

		},
		setupScroll() {

			if (this.brand && this.$refs.brands) {
				const brandDiv = this.$refs.brands.find(brand => brand.id == "brand-" + this.brand.id);
				if (brandDiv) {
					brandDiv.scrollIntoView({ block: "nearest", inline: "nearest" });
				}
			} else if (this.$refs.brandList) {
				this.$refs.brandList.scrollTop = 0;
			}

			if (this.mc) {
				const mcDiv = this.$refs.mcs?.find(mc => mc.id == "mc-" + this.mc.mcId);
				if (mcDiv) {
					mcDiv.scrollIntoView({ block: "nearest", inline: "nearest" })
				}
			} else if (this.$refs.mcList) {
				this.$refs.mcList.scrollTop = 0;
			}
		},

		isBrandIdEnabled(brandId){
			return this.enabledMcIdMap?.get(brandId);
		},

		isBrandEnabledLabel(brand){

			//console.log('FP: enabledMcIdMap: ', this.enabledMcIdMap.get(brand.id));

			if (!this.debug){
				return "";
			}


			if (this.enabledMcIdMap?.get(brand.id)) {
				return " ON";
			} else {
				return " --";
			}
			
		

		},
		filterBrandList(brandList) {

			// filtrera så filter blir reaktivt
			return brandList?.filter(brand => this.enabledMcIdMap?.get(brand?.id))

/* FP: RF 
			if (this.filterBrand == null || this.filterBrand == "") {
				return brandList;
			}

			const list = brandList.filter(brand => {

				return (brand && this.format(brand.name).includes(this.format(this.filterBrand)))

			});

			return list;*/

		},

		format(string) {

			return string.toLowerCase().replace(" ", "").replace("-", "");

		},

		filterMcList(mcList) {

			// hantera mc-listan först utifrån vad som finns i resultatet
			mcList = mcList?.filter(mc => this.enabledMcIdMap.get(mc.mcId));


			if (this.filterMc == null || this.filterMc == "") {
				return mcList;
			}

			const list = mcList.filter(mc => {

				return (mc && this.format(mc.modelName).includes(this.format(this.filterMc)))
			});

			return list;

		},
		selectBrand(brandId) {

			const brand = this.mcTree.find(brand => brand.id == brandId)

			this.setBrand(brand)

		},

	},
	created() {

	},
	updated(){
		this.setupScroll()
	}
};
</script>

<style scoped>

/*div.brandLogoList{
	background: transparent;
		display: flex;
		gap: 5px;
		flex-wrap: wrap;
		margin-top: 10px;
}*/

div.filter-wrapper.not-selected {
	background: var(--grey-2);
}

div.filter-wrapper.not-selected div.filter-button div.yearBadge {
	background: var(--grey-4);
}

div.filter-wrapper.selected div.filter-button{
	background: var(--bg-message);
	color:white;
}

div.filter-wrapper.selected div.filter-button div.yearBadge{
	background:darkblue; 
}


div.brandLogoList{
	background: transparent;
		display: grid;
		grid-template-columns: repeat(6, 1fr);
		grid-gap: 5px;
		margin-top: 10px;
		overflow:hidden;
		height:120px;
		row-gap: 0px;
}




div.brandBox {
	display: flex;
	background: var(--grey-dark-4);
	border-radius: 5px;
	justify-content: center;
	height:52px;

}



div.brandBox img {
	padding: 5px;
	object-fit: contain;
}


.font-normal { 
	font-size: var(--filter-wrapper-font-normal, 1rem);
}

.font-small {
	font-size: var(--filter-wrapper-font-small, 0.85rem);
}

div.filter-wrapper div.filter-button div.filter-button-label{
	margin-top: 2px;
}



@media (max-width:768px){
	div.filter-wrapper  {
			width:100%;
			margin-bottom:5px;
		}
 div.filter-wrapper div.filter-button{
	display: flex;
	flex-direction: row;
	
 }
 div.filter-wrapper div.filter-button div.filter-button-label {
	padding-left:5px;
	margin-top: 0px;
 }
}

div.mcLabel {
	padding: 5px;
}

@media (max-width:768px) {
	div.mcLabel {
		padding: 10px;
	}
}

b.disabled{
	color:var(--font-color-grey-light);
}

div.disabled {
	color: var(--font-color-grey-light);
}


</style>